


















































































































import Vue from "vue";
import ScrollReveal from "scrollreveal";
import HeaderImg from "@/components/shared/header-img/HeaderImg.vue";
import { scrollConfig } from "@/resources/animations/configs.ts";

export default Vue.extend({
  name: "ClinicalTrialDetail",
  components: { HeaderImg },
  data() {
    return {
      loading: true,
      detailHeaderImg: {
        path: "clinical-trials",
        image: "",
        imageAlt: "clinical trial detail"
      },
      overviewFields: [
        { label: 'Trial Status', key: 'status' },
        { label: 'Trial ID', key: 'trialId' },
        { label: 'NCT ID', key: 'nctId' },
        { label: 'ANZCTR ID (Australia)', key: 'anzctrId' },
        { label: 'EudraCT ID', key: 'eudraCtId' }, 
        { label: 'EU Trial (CTIS) Number', key: 'ctisNumber' }, 
        { label: 'Sponsor', key: 'sponsor' },
        { label: 'Type', key: 'type' },
        { label: 'Estimated Enrolment', key: 'enrolment' },
        { label: 'Trial Period', key: 'trialPeriod' }
      ],
      requirementFields: [
        { label: 'Age Range', key: 'age' },
        { label: 'Sex', key: 'sex' },
        { label: 'Healthy Volunteers', key: 'healthyVolunteers' }
      ],
      trial: {} as any
    };
  },
  created() {
    this.initHeaderImg();
    this.getTrialDetail();
  },
  mounted() {
    window.scrollTo(0, 0);
    window.addEventListener("resize", this.initHeaderImg);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.initHeaderImg);
  },
  methods: {
    setRevealAnimation() {
      this.$nextTick(() => {
        ScrollReveal().reveal(`[v-scrollReveal]`, scrollConfig);
      });
    },
    initHeaderImg() {
      const width = window.innerWidth || document.documentElement.clientWidth;
      this.detailHeaderImg.image = width > 599 
        ? "desktop_clinical_trials_top_img.jpg" 
        : "mobile_clinical_trials_top_img.jpg";
    },
    getTrialDetail() {
      this.loading = true;
      const trialId = this.$route.params.id;

      setTimeout(() => {
        const trialData = [
          {
            id: "DF003-001",
            title: "Evaluating the Safety, Tolerability, and Pharmacokinetics of DF-003 in Healthy Subjects",
            phase: "Phase 1",
            status: "Completed",
            trialId: "DF-003-1001",
            nctId: "NCT05997641",
            anzctrId: "N/A",
            eudraCtId: "N/A",
            ctisNumber: "N/A",
            sponsor: "Shanghai Yao Yuan Biotechnology Ltd. (Drug Farm)",
            type: "Interventional",
            enrolment: 96,
            trialPeriod: "Sep 2023 - Jan 2025",
            age: "18 - 55 Years",
            sex: "Male & Female",
            healthyVolunteers: "Yes",
            medicalCondition: "Healthy Subjects",
            drugs: ["DF-003"],
            showEap: false, // 不显示EAP标识
            details: [
              "A Double-Blind, Randomized, Placebo-Controlled, First-in-Human Study to Evaluate the Safety, Tolerability, and Pharmacokinetics of Orally Administered DF-003 Following Single (Part 1) and Multiple (Part 2) Ascending Doses in Healthy Subjects.",
              "The goal of this clinical trial is to evaluate the safety, tolerability, and pharmacokinetics (PK; drug metabolism) of DF-003 after oral administration of single and multiple ascending doses in healthy subjects. The choice of using healthy subjects is standard in establishing the preliminary safety and PK profile of a drug.",
              "DF-003 is a potent small molecule inhibitor of alpha-kinase 1 (ALPK1), which plays an important role in immunity and inflammation. DF-003 can inhibit the immune inflammatory response and has been shown to reduce renal fibrosis in preclinical models. Thus, this study aims to determine the role of DF-003 in the treatment of chronic kidney disease.",
              "This study will include 2 parts. Part 1 is a single ascending dose (SAD) phase with an optional food effect (FE) assessment, while Part 2 is a multiple ascending dose (MAD) phase. Part 1 - SAD Phase with optional FE assessment will include approximately 64 subjects (up to 8 cohorts of 8 subjects each) and Part 2 - MAD Phase will include approximately 32 subjects (up to 4 cohorts of 8 subjects each). Therefore, up to 96 subjects will be included in the study.",
              "Study participants will be screened approximately 42 days within the first scheduled administration of study medication. Screening data will be reviewed to determine subject eligibility. In Part 1, subjects will be randomly assigned to receive a single oral dose of DF-003 (3 x 1 milligram capsules) or matching placebo. The doses to be evaluated in Part 2 will be determined based on review of the available safety and PK data from Part 1.",
              "Subjects will be monitored for adverse events (AEs) and data will be collected for physical examination, eye examination, vital signs, 12-lead electrocardiogram (ECG), Holter monitoring, and clinical laboratory findings at various timepoints throughout the study."
            ],
            inclusionCriteria: [
              "Provision of signed and dated informed consent form (ICF).",
              "Ability to understand and stated willingness to comply with all study procedures and availability for the duration of the study, and likeliness to complete the study as planned, per the Investigator's opinion.",
              "Healthy adult male or female.",
              "If male, meets one of the following criteria: Is able to procreate and agrees not to donate sperm from the first study drug administration to at least 90 days after the last study drug administration in addition to: Having a female partner who is postmenopausal, surgically sterile, or otherwise incapable of becoming pregnant, OR Having a female partner who is a woman of childbearing potential and agrees to use a highly effective method of contraception from the first study drug administration to at least 90 days after the last study drug administration, OR Is unable to procreate; defined as surgically sterile (ie, has undergone a vasectomy at least 180 days prior to the first study drug administration).",
              "If female, meets one of the following criteria: Physiological postmenopausal status, defined as the following: Amenorrhea for at least 12 months prior to the first study drug administration (without an alternative medical condition); AND Follicle stimulating hormone (FSH) levels ≥40 mIU/mL at Screening; In the absence of 12 months of amenorrhea, 2 FSH measurements at least 3 months apart and in the postmenopausal range must be documented. Surgical postmenopausal status, defined as having had a bilateral oophorectomy or bilateral salpingo-oophorectomy with FSH levels ≥ 40 mIU/mL at Screening.",
              "Aged at least 18 years but not older than 55 years at the time of Screening.",
              "Body mass index (BMI) within 18.0 kg/m^2 to 32.0 kg/m^2, inclusively.",
              "Non- or ex-smoker (An ex-smoker is defined as someone who completed stopped using nicotine products for at least 3 months prior to the first study drug administration).",
              "Have no clinically significant diseases captured in the medical history or evidence of clinically significant findings on the physical examination, vital signs, eye examination, and/or ECG, as determined by an Investigator.",
              "A 12-lead ECG that meets the following criteria (ECG intervals will be based on the mean value of triplicate ECGs [rounded to the nearest whole number] collected at Screening): Heart rate ≥45 to ≤100 beats per minute; QT interval corrected for heart rate (QTc) according to Fridericia's formula (QTcF) ≤450 ms (males) or ≤470 ms (females); QRS interval <120 ms; PR interval ≤200 ms."
            ],
            exclusionCriteria: [
              "Female who is lactating.",
              "Female who is pregnant according to the pregnancy test at Screening or prior to the first study drug administration.",
              "Female using the following systemic contraceptives: oral, patch or vaginal ring, in the 28 days prior to the first study drug administration.",
              "Female using hormone replacement therapy in the 28 days prior to the first study drug administration.",
              "Female using the following systemic contraceptives: injections or implant, or hormone-releasing intrauterine device in the 13 weeks prior to the first study drug administration.",
              "History of significant hypersensitivity to products related to DF-003 (including excipients of the formulations) as well as severe hypersensitivity reactions (like angioedema) to any drugs.",
              "Presence or history of significant gastrointestinal, liver or kidney disease, or surgery (with the exception of cholecystectomy and appendectomy) that may affect drug bioavailability.",
              "History of significant cardiovascular, pulmonary, hematologic, neurological, psychiatric, endocrine, immunologic, rheumatologic, neoplastic, metabolic, or dermatologic disease.",
              "Presence of clinically significant ECG abnormalities at the Screening visit, as defined by medical judgment.",
              "Use of contact lenses or eyeglasses.",
              "Presence of clinically significant visual acuity or slit-lamp biomicroscopy abnormalities at the Screening visit, as defined by medical judgement.",
              "History or family history of chronic inflammatory skin disease (eg, psoriasis, atopic dermatitis, drug-related rash, or chronic urticaria), or immune or autoimmune related disorders, diseases, or syndromes.",
              "Major surgery (eg, requiring general anesthesia) within 12 weeks before Screening, during the study, or within 12 weeks after the last dose of study drug. NOTE: Subjects with planned surgical procedures to be conducted under local anesthesia may participate.",
              "Presence of renal dysfunction at Screening (eg, estimated glomerular filtration rate < 90 mL/min/1.73 m^2 calculated by the Chronic Kidney Disease Epidemiology Collaboration formula).",
              "Maintenance therapy with any drug or significant history of drug dependency or alcohol abuse (> 3 units of alcohol per day, intake of excessive alcohol, acute or chronic).",
              "Any clinically significant illness including current acute or chronic infections in the 28 days prior to the first study drug administration.",
              "Use of any prescription drugs in the 28 days prior to the first study drug administration, that in the opinion of an Investigator would put into question the status of the participant as healthy.",
              "Use of St. John's wort in the 28 days prior to the first study drug administration.",
              "Use of any over-the-counter medications 7 days prior to the first study drug administration. Subjects will be reminded that over-the-counter medications include cold preparations, aspirin, vitamins and natural products used for therapeutic benefits, and antacid preparations.",
              "Positive test result for alcohol and/or drugs of abuse at Screening or prior to the first drug administration.",
              "Positive screening results to HIV Ag/Ab combo, hepatitis B surface antigen, or hepatitis C virus tests.",
              "Any other clinically significant abnormalities in laboratory test results at Screening that would, in the opinion of an Investigator, increase the subject's risk of participation, jeopardize complete participation in the study, or compromise interpretation of study data.",
              "Intake of an IP in the 4 weeks (or 5 half-lives, whichever is longer) prior to the first study drug administration.",
              "Intake of any biological products in the 12 months prior to the first study drug administration.",
              "Current participation in another clinical or medical interventional research study.",
              "Employee of the Sponsor, Investigator or study site with direct involvement in the proposed study or other studies under the direction of that Investigator or study site, as well as family members of the employees or Investigator.",
              "Donation of plasma in the 7 days prior to the first study drug administration.",
              "Donation of 1 unit of blood to American Red Cross or equivalent organization or donation of over 500 mL of blood in the 56 days prior to the first study drug administration.",
              "Presence or history of eye lens opacification (cataracts) and eye lens degeneration."
            ],
            locations: [{ name: "Altasciences Clinical Los Angeles, Inc", address: "Cypress, California, United States, 90630", status: "Completed" }]
          },
          {
            id: "DF003-002",
            title: "Evaluating the Safety and Tolerability of Orally Administered DF-003 in ROSAH Syndrome Patients",
            phase: "Phase 1b",
            status: "Recruiting",
            trialId: "DF-003-1002",
            nctId: "NCT06395285",
            anzctrId: "N/A",
            eudraCtId: "N/A",
            ctisNumber: "N/A",
            sponsor: "Shanghai Yao Yuan Biotechnology Ltd. (Drug Farm)",
            type: "Interventional",
            enrolment: 12,
            trialPeriod: "May 2025 - May 2026 (Estimated)",
            age: "18 - 65 Years",
            sex: "Male & Female",
            healthyVolunteers: "No",
            medicalCondition: "ROSAH",
            drugs: ["DF-003"],
            showEap: true, // 显示EAP标识
            details: [
              "This is a Phase Ib open-label, single-arm, single-dose study that will be conducted in up to 12 ROSAH syndrome patients. The study will investigate the safety, tolerability, pharmacokinetics (PK), and pharmacodynamics (PD) of DF-003 (study drug). DF-003 will be administered orally (PO), once daily (QD) for 28 days (4 weeks). Patients will be followed up for 8 weeks after administration of the last dose of study drug.",
              "A total of 8 patients will be evaluated in one cohort. The cohort will have a minimum of 6 patients. Additional patients (maximum of 12 patients) may be enrolled in the event of insufficient data after a review of safety data by the Study Safety Committee. Patients will receive loading doses of 140 mg DF-003 on Days 1, 2, and 3, followed by a maintenance dose of 45 mg DF-003 starting on Day 4 through Day 28. Individual dose modification is not allowed in this study."
            ],
            inclusionCriteria: [
              "Sufficient understanding of the purpose and procedures required for the study.",
              "Body mass index (BMI) of 18.0 to 35.0 kg/m2, inclusive.",
              "Genetic testing for ALPK1 mutations that has been shown to be associated with ROSAH syndrome (e.g. T237M or Y254C, or T237A mutations).",
              "Signs of uveitis (anterior and/or posterior) in the eye (e.g. macula edema, optic nerve edema, retinal vasculitis, or retinal vascular leakage).",
              "Patients must be deemed healthy except for diagnosis of ROSAH syndrome and its clinical manifestation.",
              "Patients must be at least 18 years of age but no older than 65 years of age at the time of Screening."
            ],
            exclusionCriteria: [
              "Males who plan to father a child or donate sperm while enrolled in this study or within 90 days after the last dose of study drug.",
              "Females who are pregnant, breastfeeding, planning to become pregnant, or planning to donate eggs while on study medication or within 90 days after the last dose of study drug.",
              "Use of any of the following prohibited medications: Agents that are known to have systemic anti-inflammatory responses or high risk for nephrotoxicity or hepatotoxicity; Moderate CYP3A4 inhibitors: e.g., amiodarone, amprenavir, conivaptan, delavirdine, diltiazem, erythromycin, fluconazole, fosamprenavir, imatinib, miconazole, verapamil, grapefruit juice, cat's claw (Dolichandra unguis-cati), Echinacea augustifolia, wild cherry, chamomile, licorice; Strong CYP3A4 inhibitors: e.g., ceritinib, clarithromycin, cobicistat, elvitegravir/ritonavir, idelalisib, indinavir/ritonavir, itraconazole, ketoconazole, lopinavir/ritonavir, nefazodone, nelfinavir, paritaprevir/ritonavir, ombitasvir/paritaprevir/ritonavir (and/or dasabuvir), posaconazole, ritonavir, saquinavir/ritonavir, telithromycin, tipranavir/ritonavir, voriconazole; Strong CYP3A4 inducers: apalutamide, carbamazepine, enzalutamide, ivosidenib, lumacaftor/ivacaftor, mitotane, phenytoin, rifampin, St. John's wort; Digoxin; Agents known to cause Torsade de Pointes: Disopyramide, procainamide, quinidine, sotalol, azithromycin, clarithromycin, erythromycin, ciprofloxacin, levofloxacin, moxifloxacin, fluconazole, ketoconazole, pentamidine, voriconazole, haloperidol, thioridazine, ziprasidone, citalopram, escitalopram, dolasetron, droperidol, granisetron, and ondansetron; Investigational agents (small molecules and oligonucleotides), vaccines, or invasive medical devices within 28 days (4 weeks, or 5 half-lives, whichever is longer) prior to enrollment or having received a biological product within 6 months prior to enrollment.",
              "History of significant hypersensitivity to products related to DF-003 (including excipients of the formulations) as well as severe hypersensitivity reactions (like angioedema) to any drugs.",
              "Recent (within 3 months prior to screening) or acute changes in the following laboratory values: Platelet count ≤ 120,000/mm3, OR Alanine aminotransferase (ALT) or aspartate aminotransferase (AST) > ULN, OR Bilirubin (total, direct) > ULN, OR International Normalization Ratio (INR) > ULN, OR Serum albumin less than the lower limit of normal, OR Estimated creatinine clearance < 70 mL/min/1.73 m2 at Screening, calculated by the Chronic Kidney Disease Epidemiology Collaboration (CKD-EPI) formula, OR Hemoglobin A1c (HbA1c) > 8%.",
              "Moderate or severe hepatic impairment (categorized as Child-Pugh class B and C, respectively, on the Child-Pugh Score for Cirrhosis Mortality)."
            ],
            locations: [
              { name: "National Institutes of Health Clinical Center", address: "Bethesda, Maryland, United States, 20892", status: "Withdrawn" },
              { name: "Duke Eye Center - Duke University Hospital", address: "Durham, North Carolina, United States, 27705", status: "Recruiting" },
              { name: "John A. Moran Eye Center - University of Utah Health", address: "Salt Lake City, Utah, United States, 84132", status: "Recruiting" },
              { name: "Save Sight Institute - University of Sydney Eye Hospital", address: "Sydney, New South Wales, Australia, 2000", status: "Recruiting" }
            ]
          },
          {
            id: "DF006-001",
            title: "A Phase 1, Placebo-controlled, First-in-human Study of Orally Administered DF-006 to Evaluate the Safety, Tolerability, and Pharmacokinetics After a Single Dose and Multiple Doses in Healthy Subjects",
            phase: "Phase 1",
            status: "Completed",
            trialId: "DF-006-1001",
            nctId: "N/A",
            anzctrId: "ACTRN12621000592842",
            eudraCtId: "N/A",
            ctisNumber: "N/A",
            sponsor: "Zhejiang Yao Yuan Biotechnology Ltd. (Drug Farm)",
            type: "Interventional",
            enrolment: 50,
            trialPeriod: "Jul 2021 - Nov 2022",
            age: "18 - 55 Years",
            sex: "Male & Female",
            healthyVolunteers: "Yes",
            medicalCondition: "Healthy Subjects",
            drugs: ["DF-006"],
            showEap: false, // 不显示EAP标识
            details: [
              "A Phase 1, Double-blind, Randomized, Placebo-controlled, First-in-human Study of Orally Administered DF-006 to Evaluate the Safety, Tolerability, and Pharmacokinetics After a Single Dose and Multiple Doses of Orally Administered DF 006 in Healthy Subjects (Part 1 and Part 2).",
              "Healthy subjects in Part 1 will receive a single oral liquid dose of DF-006, starting at 3mcg, for one day. Subsequent doses will be based on safety data from prior patients and cohorts.",
              "Healthy subjects in Part 2 will receive a single oral liquid dose of DF-006 weekly for 14 days, starting at the dose determined in Part 1. Participants in Part 2 are likely to be different from participants in Part 1.",
              "A Study Safety Committee will provide safety oversight and will follow Dose Selection Guidelines to determine cohort doses. Cohort progression will be based on Data Review Meetings. In Part 1, cohort progression will occur approximately every 3 weeks. In Part 2, cohort progression will occur approximately every 4 weeks. Adherence to the intervention will be monitored by direct observation of dosing."
            ],
            inclusionCriteria: [
              "Female subjects must have a negative serum pregnancy test and must not be of childbearing potential.",
              "Male subjects must be either surgically sterile, or incapable of fathering a child, or have a heterosexual partner partner who is not pregnant or of childbearing potential.",
              "Nonsmoker within last 3 months.",
              "BMI of 18.0 to 32.0 kg/m2.",
              "Subjects must be deemed healthy by the Investigator on the basis of a medical evaluation."
            ],
            exclusionCriteria: [
              "Evidence of clinically significant cardiac history.",
              "Personal or family history of chronic inflammatory skin disease or immune or autoimmune related disorders, diseases or syndromes.",
              "History or current evidence of use of amphetamines, barbiturates, narcotic or other drugs of abuse/recreational drug use, except under physician supervision.",
              "Excessive use of alcohol and unwilling to abstain from alcohol use for 48 hours prior to start of dosing through end of study follow-up.",
              "Subjects with current hepatitis A, B, C, D, E, HIV, infection or acute infection such as SARS-CoV-2 (COVID-19).",
              "Subjects with kidney disease or significant abnormal vital signs."
            ],
            locations: [
              { name: "New Zealand", address: "N/A", status: "Completed" },
              { name: "Korea, Republic Of", address: "N/A", status: "Completed" }
            ]
          },
          {
            id: "DF006-002",
            title: "A Phase 1, Placebo-controlled, First-in-human Study of Orally Administered DF-006 to Evaluate the Safety, Tolerability, and Pharmacokinetics After Multiple Doses in Chronic Hepatitis B subjects",
            phase: "Phase 1",
            status: "Completed",
            trialId: "DF-006-1001",
            nctId: "N/A",
            anzctrId: "ACTRN12623000997651",
            eudraCtId: "N/A",
            ctisNumber: "N/A",
            sponsor: "Zhejiang Yao Yuan Biotechnology Ltd. (Drug Farm)",
            type: "Interventional",
            enrolment: 26,
            trialPeriod: "Jul 2023 - Apr 2024",
            age: "18 - 65 Years",
            sex: "Male & Female",
            healthyVolunteers: "No",
            medicalCondition: "Chronic Hepatitis B",
            drugs: ["DF-006"],
            showEap: false, // 不显示EAP标识
            details: [
              "A Phase 1, Double-blind, Randomized, Placebo-controlled, First-in-human Study of Orally Administered DF-006 to Evaluate the Safety, Tolerability, and Pharmacokinetics After Multiple Doses of Orally Administered DF-006 in Chronic Hepatitis B Patients.",
              "This is a double-blind, randomized, placebo-controlled, multiple-ascending doses (MAD) study that will be conducted in up to 120 chronic hepatitis B (CHB) subjects. Hepatitis B e-antigen (HBeAg)-negative virologically suppressed (VS), HBeAg-negative treatment naïve (TN), or currently untreated (CU) CHB subjects with abnormal serum alanine aminotransferase (ALT), and HBeAg-positive TN or CU CHB subjects with normal serum ALT will be evaluated in separate MAD cohorts of up to 40 subjects each.",
              "This study will investigate the safety, tolerability, PD, and antiviral activity of once weekly (QW) oral (PO) doses of DF-006 for 4 weeks. Subject follow-up will occur for 4 weeks after administration of the last dose of study drug. Subsequent cohort dosage (multiple-ascending doses) and dosing frequency will be based on Dose Selection Guidelines and prior cohort CHB subject data.",
              "Three cohorts of HBeAg-negative VS CHB subjects of 8 subjects each (24 subjects in total), and up to 2 optional cohorts of 8 subjects each (16 subjects in total), will receive once QW PO doses of DF-006 or matching placebo for a duration of 4 weeks. Within each cohort, 6 subjects will be randomly assigned to receive DF-006, and 2 subjects will receive matching placebo.",
              "Three cohorts of HBeAg-negative TN/CU CHB subjects with abnormal serum ALT of 8 subjects each (24 subjects in total), and up to 2 optional cohorts of 8 subjects each (16 subjects in total) will receive PO QW doses of DF-006 or matching placebo for a duration of 4 weeks. Within each cohort, 6 subjects will be randomly assigned to receive DF-006, and 2 subjects will receive matching placebo.",
              "Three cohorts of HBeAg-positive TN/CU CHB subjects with normal serum ALT of 8 subjects each (24 subjects in total), and up to 2 optional cohorts of 8 subjects each (16 subjects in total), will receive PO QW doses of DF-006 or matching placebo for a duration of 4 weeks. Within each cohort, 6 subjects will be randomly assigned to receive DF-006, and 2 subjects will receive matching placebo.",
              "The starting dose for Part 3 is 0.4 mcg PO QW for 4 weeks. This dose was selected by a Study Safety Committee following a review of all the preliminary blinded the safety data from Parts 1 and 2 of this study."
            ],
            inclusionCriteria: [
              "Subject must sign an informed consent form (ICF) indicating that he or she understands the purpose of, and procedures required for, the study and is willing to participate in the study.",
              "In the Investigator’s opinion, the subject is able to understand and comply with protocol requirements, instructions, and protocol stated restrictions and is likely to complete the study as planned.",
              "Female subjects must NOT be of childbearing potential, which is defined as postmenopausal or permanently sterile, OR, if they are a woman of childbearing potential (WOCBP), must agree to use a condom and/or highly effective contraceptive therapy.",
              "Male subjects must be either surgically sterile (eg, had a vasectomy), or otherwise incapable of fathering a child; OR, if non-sterile and heterosexually active, must have a partner who is postmenopausal, surgically sterile; OR, if their partner is WOCBP, must use highly effective methods of contraception from the time of male subject's Screening until at least 90 days after the last dose of study drug.",
              "Subjects must have a BMI of 18.0 to 35.0 kg/m^2.",
              "Subjects must have CHB infection documented by serum HBsAg-positive at Screening and at least 6 months prior to Screening."
            ],
            exclusionCriteria: [
              "Evidence of clinically significant cardiac history.",
              "Personal or family history of chronic inflammatory skin disease or immune or autoimmune related disorders, diseases or syndromes.",
              "History or current evidence of use of amphetamines, barbiturates, narcotic or other drugs of abuse/recreational drug use, except under physician supervision.",
              "Excessive use of alcohol and unwilling to abstain from alcohol use for 48 hours prior to start of dosing through end of study follow-up.",
              "Subjects with kidney disease or significant abnormal vital signs.",
              "Female subjects who are pregnant, breastfeeding, or planning to become pregnant while on study medication or within 90 days after the last dose of study drug.",
              "Subjects positive for anti-HBs.",
              "Subjects with any history or current evidence of hepatic decompensation.",
              "History or current evidence of hepatic decompensation, cirrhosis, liver fibrosis, or hepatocellular carcinoma.",
              "Subjects with liver disease of non-HBV etiology."
            ],
            locations: [
              { name: "New Zealand", address: "N/A", status: "Completed" },
              { name: "Ukraine", address: "N/A", status: "Completed" },
              { name: "Moldova, Republic Of", address: "N/A", status: "Completed" }
            ]
          }
        ];

        const found = trialData.find(item => item.id === trialId || item.nctId === trialId);
        if (found) {
          this.trial = found;
          this.setRevealAnimation();
        }
        this.loading = false;
      }, 500);
    }
  }
});
